import React from 'react';

const WebformDebug = (props) => (
	<code style={{ display: 'none' }}>
		{console.log('Element is not mapped: ', props)}
	</code>
);

export default WebformDebug
